const SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
const SCRIPT_LOAD_TIMEOUT_MS = 15000;
let pendingScript = null;

export const verificationError = (code, message) => Object.assign(new Error(message), { code });

// Share the preload and form requests. A failed load must be retried on the next
// submission instead of leaving every form stuck until the page is reloaded.
export function loadTurnstile() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return Promise.reject(verificationError('unavailable', 'Browser verification is unavailable'));
  }
  if (pendingScript) return pendingScript;
  if (window.turnstile) return Promise.resolve(window.turnstile);

  const loading = new Promise((resolve, reject) => {
    let settled = false;
    const script = document.createElement('script');
    script.src = SCRIPT_URL;
    script.async = true;
    script.defer = true;

    const finish = (error) => {
      if (settled) return;
      settled = true;
      clearTimeout(timeout);
      script.onload = null;
      script.onerror = null;
      if (error) {
        script.remove();
        reject(error);
      } else {
        resolve(window.turnstile);
      }
    };
    const unavailable = () => finish(verificationError('script_unavailable', 'Browser security check could not load'));
    const timeout = setTimeout(unavailable, SCRIPT_LOAD_TIMEOUT_MS);
    script.onerror = unavailable;
    script.onload = () => {
      // The load event runs after api.js has executed. Do not call ready():
      // Cloudflare throws from that helper for async/defer script tags, leaving
      // this shared promise pending until it incorrectly reports a timeout.
      if (window.turnstile) {
        finish();
      } else {
        unavailable();
      }
    };
    document.head.appendChild(script);
  });
  pendingScript = loading.finally(() => { pendingScript = null; });
  return pendingScript;
}
